export default __webpack_public_path__ + "static/img-about-us-03c57ad08a8c8e0487a0be37e193a5a5.png";